<template>
    <div>
      <LedgerBankList v-show="listView" @newLedger="onClickNewFromList" @editLedger="onClickEditFromList"  @importLedger="onClickImportFromList" :scroll="corY" ref="refreshList" />
      <LedgerBankForm v-show="formView" :ledger="ledger" @backClicked="onBackChild" />
      <LedgerBankImport v-show="importView" @back="onBackChild"/>
    </div>
</template>

<script>
import LedgerBankList from '@/components/finance/LedgerBankList.vue'
import LedgerBankForm from '@/components/finance/LedgerBankForm.vue'
import LedgerBankImport from '@/components/finance/LedgerBankImport.vue'
import { mapState } from 'vuex'

export default {
  name: 'LedgerBank',
  components: {
    LedgerBankList,
    LedgerBankForm,
    LedgerBankImport
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList
    })
  },
  mounted () {
    this.$store.dispatch('getBankList')
    this.$store.dispatch('getCompanyList')
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      importView: false,
      saldo: 0,
      ledger: {
        id: null,
        bank_id: null,
        date: null,
        notes: null,
        debit: '0',
        credit: '0',
        parent_id: null,
        status: null,
        lock: false,
        template_id: null,
        company_no: null,
        journals: [{
          id: null,
          journal_code: null,
          type_id: null,
          journal_date: null,
          ref_no: null,
          contact: null,
          journal_description: null,
          status: null,
          debit: '0',
          credit: '0',
          branch_no: null,
          company_no: null,
          auto: false,
          details: [{
            id: null,
            journal_code: null,
            account_code: null,
            account: null,
            remark: null,
            debit: '0',
            credit: '0',
            branch_no: null,
            company_no: null,
            journal_date: null
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          user_id: null,
          user: null,
          ref: null,
          description: null
        }]
      }
    }
  },
  methods: {
    async onClickNewFromList () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.importView = false
      this.ledger = {
        id: null,
        bank_id: null,
        date: new Date().toISOString(),
        notes: null,
        debit: '0',
        credit: '0',
        parent_id: null,
        status: null,
        lock: false,
        template_id: null,
        company_no: this.authUser.company_no,
        journals: [{
          id: null,
          journal_code: null,
          type_id: null,
          journal_date: null,
          ref_no: null,
          contact: null,
          journal_description: null,
          status: null,
          debit: '0',
          credit: '0',
          branch_no: null,
          company_no: null,
          auto: false,
          details: [{
            id: null,
            journal_code: null,
            account_code: null,
            account: null,
            remark: null,
            debit: '0',
            credit: '0',
            branch_no: null,
            company_no: null,
            journal_date: null
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          user_id: null,
          user: null,
          ref: null,
          description: null
        }]
      }
    },
    async onClickEditFromList (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.ledger = value
      this.listView = false
      this.formView = true
      this.importView = false
    },
    async onClickImportFromList () {
      this.listView = false
      this.formView = false
      this.importView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.importView = false
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
      window.scrollTo(0, 0)
      this.ledger = {
        id: null,
        bank_id: null,
        date: null,
        notes: null,
        debit: '0',
        credit: '0',
        parent_id: null,
        status: null,
        lock: false,
        template_id: null,
        company_no: null,
        journals: [{
          id: null,
          journal_code: null,
          type_id: null,
          journal_date: null,
          ref_no: null,
          contact: null,
          journal_description: null,
          status: null,
          debit: '0',
          credit: '0',
          branch_no: null,
          company_no: null,
          auto: false,
          details: [{
            id: null,
            journal_code: null,
            account_code: null,
            account: null,
            remark: null,
            debit: '0',
            credit: '0',
            branch_no: null,
            company_no: null,
            journal_date: null
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          user_id: null,
          user: null,
          ref: null,
          description: null
        }]
      }
    }
  }
}
</script>
